export { default } from './CourseCompare.container';
export { default as Component } from './CourseCompare';
